<div *ngIf="isLoading" class="d-flex justify-content-center align-items-center">
  <div class="spinner-grow me-2" role="status">
    <span class="sr-only">{{ message }}...</span>
  </div>
  <span>{{ message }}</span>
</div>
